import React from 'react';
import Profile from '../features/Profile/components/Profile';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Chats from '../features/Chats/components/Chats';
import { Box, Button, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { variants } from '../variants/variants';
import { ArrowBackIosNewRounded } from '@mui/icons-material';

const ProfilePage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const activeChat = pathname.split('/')[2] === 'chats';
  const empcode = pathname.split('/')[3];
  const isNotChat = pathname.split('/').length > 4;
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));
  const handleNavigateBack = () => {
    // window.history.back()
    navigate(`/home/chats/${empcode}`);
  };

  return (
    <div style={{ height: '100%' }}>
      {activeChat ? (
        isMd ? (
        //   isNotChat ? (
        //     <>
        //       {/* <Box
        //         sx={ {
        //                 display: 'flex',
        //                 justifyContent: 'flex-start',
        //                 width: '100%',
        //                 p: 1,
        //                 borderBottom: 1,
        //                 borderColor: 'divider',
        //                 background: variants.boxBackground.NAVBAR,
        //                 borderRadius: variants.boxRadius.NAVBAR,
        //                 alignItems: 'center',
        //               }
        //         }
        //       >
        //         {isMd && (
        //           <IconButton
        //             id="backToHome"
        //             onClick={handleNavigateBack}
        //             sx={{
        //               p: 0,
        //               pr: 1,
        //               display: 'none',
        //               [theme.breakpoints.down('lg')]: {
        //                 display: 'flex',
        //               },
        //             }}
        //           >
        //             <ArrowBackIosNewRounded fontSize="small" />
        //           </IconButton>
        //         )}
        //         <Typography
        //   sx={{
        //     fontSize: variants.BODY,
        //     [theme.breakpoints.down('lg')]: {
        //       fontSize: variants.TINY,
        //     },
        //   }}
        // >
        //   Go back to Chat
        // </Typography>
        //       </Box> */}
        //       {/* <Button variant="outlined" onClick={handleNavigateBack}>Back to Chat</Button> */}
        //       <Outlet />
        //     </>
        //   ) : 
          (
            <Outlet />
          )
        ) : (
          <Chats />
        )
      ) : (
        <Profile />
      )}
    </div>
  );
};

export default ProfilePage;
